import React, { useState } from "react";
import axios from "axios";
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_API_URL 


const LoginForm = ({ onLogin }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    

    const handleSubmit = async (e) => {
        e.preventDefault();


        try {

            const response = await axios.post(`${BACKEND_URL}/auth/login`, {
                username,
                password,
                rememberMe,
            });

            const { token, user } = response.data;

            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem("authToken", token);
            storage.setItem("authUser", JSON.stringify(user));

            setError("");
            onLogin(user);

        } catch (err) {

            
            // Trata erros de login (ex: 401 Credenciais inválidas)
            const errorMessage = err.response?.data?.error || "Ocorreu um erro desconhecido. Verifique a conexão com o servidor.";
            setError(errorMessage);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Login</h2>
                <input
                    className="login-input"
                    placeholder="Usuário"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <div style={{ position: "relative", marginBottom: "1rem" }}>
                    <input
                        className="login-input"
                        type={showPassword ? "text" : "password"}
                        placeholder="Senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{ paddingRight: 40, marginBottom: 0 }}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(v => !v)}
                        style={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 4,
                            color: showPassword ? "#1976d2" : "#aaa",
                            display: "flex",
                            alignItems: "center",
                            transition: "color 0.2s",
                        }}
                        title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                    >
                        {showPassword ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" opacity="0.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                <circle cx="12" cy="12" r="3"/>
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" opacity="0.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                                <line x1="1" y1="1" x2="23" y2="23"/>
                            </svg>
                        )}
                    </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', justifyContent: 'center' }}>
                    <input
                        type="checkbox"
                        id="rememberMe"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        style={{ marginRight: '10px' }}
                    />
                    <label htmlFor="rememberMe" style={{ fontSize: '14px', color: '#555' }}>Manter conectado</label>
                </div>

                {error && <div className="login-error">{error}</div>}

                <button className="login-button" type="submit">
                    Entrar
                </button>
            </form>
        </div>
    );
};

export default LoginForm;
